// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__xm8FE","links":"Footer_links__+UqIY","supportLink":"Footer_supportLink__vOMsh","sign":"Footer_sign__vD5fz"};